/**
 * SourceBadge — F18 T18.3.z.UI1.
 *
 * Pokazuje skąd przyszła faktura zakupu: manual / symfonia / ksef (future).
 * Używany w listing PurchaseInvoices + detail PurchaseInvoiceDetail.
 *
 * Wzorzec: kolorowy badge z ikonką ERP / Pencil / Receipt. Klient widzi na pierwszy
 * rzut oka czy faktura była wciągnięta automatycznie czy wpisana ręcznie.
 */

import { useTranslation } from 'react-i18next';
import { ArrowLeftRight, FileText, Pencil } from 'lucide-react';

import { Badge } from '@/components/Badge';

interface Props {
  source: string | null;
}

export function SourceBadge({ source }: Props) {
  const { t } = useTranslation();
  const normalizedSource = source ?? 'manual';

  if (normalizedSource === 'symfonia') {
    return (
      <Badge color="accent">
        <ArrowLeftRight className="mr-1 inline h-3 w-3" aria-hidden="true" />
        {t('tenant.purchaseInvoices.source.symfonia')}
      </Badge>
    );
  }

  if (normalizedSource === 'ksef') {
    return (
      <Badge color="blue">
        <FileText className="mr-1 inline h-3 w-3" aria-hidden="true" />
        {t('tenant.purchaseInvoices.source.ksef')}
      </Badge>
    );
  }

  // manual (default) lub nieznane źródło
  return (
    <Badge color="gray">
      <Pencil className="mr-1 inline h-3 w-3" aria-hidden="true" />
      {t('tenant.purchaseInvoices.source.manual')}
    </Badge>
  );
}
